function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83.4977 11.25C64.8869 11.25 49.7477 26.3892 49.7477 45C49.7477 63.6107 64.8869 78.75 83.4977 78.75C102.108 78.75 117.248 63.6107 117.248 45C117.248 26.3892 102.108 11.25 83.4977 11.25ZM51.6922 71.5027L34.3447 88.8503C32.8799 90.315 32.8799 92.6882 34.3447 94.153C35.8094 95.6178 38.1824 95.6178 39.6474 94.153L56.9949 76.8055C58.4597 75.3407 58.4597 72.9675 56.9949 71.5027C55.5302 70.038 53.1572 70.0377 51.6922 71.5027Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.9942 45C78.0945 45 79.7442 43.3498 79.7442 41.25V37.5C79.7442 35.3997 78.0945 33.75 75.9942 33.75C73.894 33.75 72.2442 35.3997 72.2442 37.5V41.25C72.2442 43.3498 73.894 45 75.9942 45ZM90.9942 45C93.0945 45 94.7442 43.3498 94.7442 41.25V37.5C94.7442 35.3997 93.0945 33.75 90.9942 33.75C88.894 33.75 87.2442 35.3997 87.2442 37.5V41.25C87.2442 43.3498 88.894 45 90.9942 45ZM83.4942 0C58.6692 0 38.4942 20.175 38.4942 45C38.4942 69.825 58.6692 90 83.4942 90C108.319 90 128.494 69.825 128.494 45C128.494 20.175 108.319 0 83.4942 0ZM83.4942 75C66.919 75 53.4942 61.5748 53.4942 45C53.4942 28.4247 66.919 15 83.4942 15C100.069 15 113.494 28.4247 113.494 45C113.494 61.5748 100.069 75 83.4942 75ZM72.9195 53.6247C71.4195 55.0497 71.4195 57.4497 72.9195 58.8747C74.3445 60.3747 76.7442 60.3747 78.1692 58.8747C81.0192 56.0247 85.9695 56.0247 88.8197 58.8747C89.4942 59.6252 90.4692 60 91.4442 60C92.4192 60 93.3942 59.625 94.0692 58.8747C95.5692 57.4497 95.5692 55.0497 94.0692 53.6247C88.444 47.925 78.5445 47.925 72.9195 53.6247ZM34.3415 83.5475C32.8767 82.0827 30.5035 82.0827 29.0387 83.5475L3.78223 108.803C-0.601266 113.187 -0.601265 120.321 3.77848 124.712C3.78223 124.712 3.78223 124.711 3.78223 124.715C8.16973 129.095 15.3132 129.096 19.6905 124.712L44.9467 99.4557C46.4115 97.991 46.4115 95.6178 44.9467 94.153L34.3415 83.5475Z",
  fill: "url(#paint1_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 75.2469,
  y1: 95.2515,
  x2: 75.2469,
  y2: 11.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ADDCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5028,
  stopColor: "#EAF6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAF6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 64.4942,
  y1: 128,
  x2: 64.4942,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5558FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00C0FF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 128,
  height: 128,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgNodataMagnifier = function SvgNodataMagnifier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNodataMagnifier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nodata-magnifier.335dbbbe.svg";
export { ForwardRef as ReactComponent };